const addQueue = {
  feilds: [
    {
      id: 1,
      name: "unit",
      label: "Unit *",
      placeholder: "Select Unit *",
      icon: null,
      rules: [],
      errors: [],
      valid: false,
      relation: false,
      relationvalue: [],
      state: "",
      mode: "single",
      type: "select2",
      disable: false,
      value: null,
      visiable: true,
      styles: { cols: "col-4 mb-3 mr-5" },
    },
    // {
    //   name: "qCreateType",
    //   label: "Queue Type *",
    //   placeholder: "Select Queue Type",
    //   icon: null,
    //   rules: [],
    //   errors: [],
    //   valid: false,
    //   state: "",
    //   relation: false,
    //   relationvalue: [],
    //   mode: "group",
    //   disable: true,
    //   value: null,
    //   type: "radio",
    //   styles: { cols: "col-12 mb-3 mt-2" },
    //   groupData: [
    //     {
    //       name: "room",
    //       label: "Room",
    //       placeholder: "Select Room",
    //       icon: null,
    //       rules: [],
    //       errors: [],
    //       valid: false,
    //       state: "",
    //       mode: "single",
    //       type: "radio",
    //       disable: false,
    //       value: null,
    //     },
    //     {
    //       name: "doctor",
    //       label: "Doctor",
    //       placeholder: "Select Doctor",
    //       icon: null,
    //       rules: [],
    //       errors: [],
    //       valid: false,
    //       state: "",
    //       mode: "single",
    //       type: "radio",
    //       disable: false,
    //       value: null,
    //     },
    //   ],
    // },
    {
      id: 2,
      name: "qCreateType",
      label: "Queue Type *",
      placeholder: "Select Queue Type",
      icon: null,
      rules: [],
      errors: [],
      valid: false,
      relation: false,
      relationvalue: [],
      state: "",
      mode: "single",
      type: "select2",
      disable: false,
      value: null,
      visiable: true,
      styles: { cols: "col-4" },
    },
    {
      name: "alloperator",
      label: "Operator *",
      placeholder: "Select Operator *",
      icon: null,
      rules: [],
      errors: [],
      valid: false,
      relation: true,
      relationvalue: [],
      state: "",
      mode: "single",
      type: "select2",
      disable: false,
      value: null,
      visiable: false,
      styles: { cols: "col-4 mb-3 mt-2 mr-5" },
    },
    {
      name: "technician",
      label: "Technician",
      placeholder: "Select Technician",
      icon: null,
      rules: [],
      errors: [],
      valid: false,
      relation: true,
      relationvalue: [],
      state: "",
      mode: "single",
      type: "select2",
      disable: false,
      value: null,
      visiable: false,
      styles: { cols: "col-4 mb-3 mt-2 mr-5" },
    },
    {
      name: "work_station",
      label: "Work Station *",
      placeholder: "Select Workstation",
      icon: null,
      rules: [],
      errors: [],
      valid: false,
      relation: true,
      relationvalue: [],
      state: "",
      mode: "single",
      type: "select2",
      disable: false,
      value: null,
      visiable: false,
      styles: { cols: "col-4 mb-3 mt-2 mr-5" },
    },
    {
      id: 3,
      name: "roomname",
      label: "Room Name *",
      placeholder: "Enter Room Name",
      icon: "user",
      rules: [],
      errors: [],
      valid: false,
      relation: false,
      relationvalue: [],
      state: "",
      mode: "single",
      type: "input",
      disable: false,
      value: null,
      visiable: true,
      is_remote_valid: false,
      is_remote_validation: true,
      styles: { cols: "col-4 mb-3 mt-2 mr-5" },
    },
    // {
    //   id: 4,
    //   name: "roomduration",
    //   label: "Room Duration %",
    //   placeholder: "Enter Room Duration %",
    //   icon: "user",
    //   rules: [],
    //   errors: [],
    //   valid: false,
    //   relation: false,
    //   relationvalue: [],
    //   state: "",
    //   mode: "single",
    //   type: "inputNumber",
    //   disable: false,
    //   value: null,
    //   visiable: true,
    //   is_remote_valid: false,
    //   is_remote_validation: true,
    //   styles: { cols: "col-4 mb-3 mt-2" },
    // },
    // {
    //   name: "doctorname",
    //   label: "Doctor Name *",
    //   placeholder: "Select Doctor",
    //   icon: null,
    //   rules: [],
    //   errors: [],
    //   valid: false,
    //   relation: false,
    //   relationvalue: [],
    //   state: "",
    //   mode: "single",
    //   type: "select2",
    //   disable: false,
    //   value: null,
    //   visiable: false,
    //   is_remote_valid: false,
    //   is_remote_validation: true,
    //   styles: { cols: "col-4 mb-3 mt-2" },
    // },
    {
      id: 5,
      name: "service_groups",
      label: "row",
      placeholder: "row",
      icon: null,
      rules: [],
      errors: [],
      valid: false,
      relation: false,
      relationvalue: [],
      state: "",
      mode: "table",
      type: "table",
      disable: false,
      value: null,
      rowfeilds: {
        title: null,
        type: "table",
        add_more: true,
        visible: true,
        add_more_title: "Add More",
        table_head: [
          { id: 1, text: "S.no", width: "5%" },
          { id: 2, text: "Department *", width: "40%" },
          { id: 3, text: "Service Group *", width: "40%" },
          // { id: 4, text: "Exclude Services", width: "30%" },
          { id: 6, text: "Action", width: "15%" },
        ],
        table_body: [
          {
            id: 1,
            feilds: [
              {
                id: 46,
                name: "queuedepartment",
                title: "Department ",
                visible: true,
                element: "select",
                required: false,
                type: "select",
                placeholder: "Select",
                icon: "user",
                rules: [],
                errors: [],
                value: null,
                valid: false,
                state: "",
                disable: false,
                className: "col-3",
                row_group: "ailment",
                column_group: "name",
              },
              {
                id: 44,
                name: "service_group",
                title: "Service Group",
                visible: true,
                element: "select",
                required: false,
                type: "select",
                placeholder: "Select",
                icon: "user",
                rules: [],
                errors: [],
                value: null,
                valid: false,
                state: "",
                disable: false,
                className: "col-3",
                row_group: "ailment",
                column_group: "amount",
              },
              {
                id: 44,
                name: "exclude_services",
                title: "Exclude Services",
                visible: false,
                element: "select2multiple",
                required: false,
                type: "select2multiple",
                placeholder: "Select",
                icon: "user",
                rules: [],
                errors: [],
                value: null,
                valid: false,
                state: "",
                disable: false,
                className: "col-3",
                row_group: "ailment",
                column_group: "amount",
              },
              {
                id: 1,
                name: "action",
                title: "--",
                visible: true,
                element: "text",
              },
            ],
          },
        ],
        add_more_feilds: [
          {
            id: 46,
            name: "queuedepartment",
            title: "Department",
            visible: true,
            element: "select",
            required: false,
            type: "select",
            placeholder: "Select",
            icon: "user",
            rules: [],
            errors: [],
            value: null,
            valid: false,
            state: "",
            disable: false,
            className: "col-3",
            row_group: "ailment",
            column_group: "name",
          },
          {
            id: 44,
            name: "service_group",
            title: "Service Group",
            visible: true,
            element: "select",
            required: false,
            type: "select",
            placeholder: "Selct",
            icon: "user",
            rules: [],
            errors: [],
            value: null,
            valid: false,
            state: "",
            disable: false,
            className: "col-3",
            row_group: "ailment",
            column_group: "amount",
          },
          // {
          //   id: 44,
          //   name: "exclude_services",
          //   title: "Exclude Services",
          //   visible: true,
          //   element: "select2multiple",
          //   required: false,
          //   type: "select2multiple",
          //   placeholder: "Select",
          //   icon: "user",
          //   rules: [],
          //   errors: [],
          //   value: null,
          //   valid: false,
          //   state: "",
          //   disable: false,
          //   className: "col-3",
          //   row_group: "ailment",
          //   column_group: "amount",
          // },
          {
            id: 1,
            name: "action",
            title: "--",
            visible: true,
            element: "action",
          },
        ],
      },
    },
    {
      id: 6,
      name: "wDays",
      label: "Working Days with Business Hours",
      placeholder: "Select Working Hours",
      icon: null,
      rules: [],
      errors: [],
      valid: false,
      state: "",
      relation: false,
      relationvalue: [],
      mode: "group",
      disable: true,
      value: null,
      type: "checkbox",
      visiable: false,
      groupData: [
        {
          name: 0,
          label: "Monday",
          business_day: "monday",
          placeholder: "Select day",
          icon: null,
          rules: [],
          errors: [],
          valid: false,
          state: "",
          mode: "single",
          type: "checkbox",
          disable: false,
          value: null,
          subgroupData: [
            {
              name: "monfromtime",
              label: "From Time",
              placeholder: "Select From Time",
              icon: null,
              rules: [],
              errors: [],
              valid: false,
              state: "",
              mode: "single",
              type: "time",
              disable: true,
              value: null,
              message: "Please select monday from date",
            },
            {
              name: "montotime",
              label: "To Time",
              placeholder: "Select To Time",
              icon: null,
              rules: [],
              errors: [],
              valid: false,
              state: "",
              mode: "single",
              type: "time",
              disable: true,
              value: null,
              message: "Please select monday to date",
            },
          ],
        },
        {
          name: 1,
          label: "Tuesday",
          business_day: "tuesday",
          placeholder: "Select day",
          icon: null,
          rules: [],
          errors: [],
          valid: false,
          state: "",
          mode: "single",
          type: "checkbox",
          disable: false,
          value: null,
          subgroupData: [
            {
              name: "tuefromtime",
              label: "From Time",
              placeholder: "Select From Time",
              icon: null,
              rules: [],
              errors: [],
              valid: false,
              state: "",
              mode: "single",
              type: "time",
              disable: true,
              value: null,
            },
            {
              name: "tuetotime",
              label: "To Time",
              placeholder: "Select To Time",
              icon: null,
              rules: [],
              errors: [],
              valid: false,
              state: "",
              mode: "single",
              type: "time",
              disable: true,
              value: null,
            },
          ],
        },
        {
          name: 2,
          label: "Wednesday",
          placeholder: "Select day",
          icon: null,
          rules: [],
          errors: [],
          valid: false,
          state: "",
          mode: "single",
          type: "checkbox",
          disable: false,
          value: null,
          business_day: "wednesday",

          subgroupData: [
            {
              name: "wedfromtime",
              label: "From Time",
              placeholder: "Select From Time",
              icon: null,
              rules: [],
              errors: [],
              valid: false,
              state: "",
              mode: "single",
              type: "time",
              disable: true,
              value: null,
            },
            {
              name: "wedtotime",
              label: "To Time",
              placeholder: "Select To Time",
              icon: null,
              rules: [],
              errors: [],
              valid: false,
              state: "",
              mode: "single",
              type: "time",
              disable: true,
              value: null,
            },
          ],
        },
        {
          name: 3,
          label: "Thursday",
          placeholder: "Select day",
          business_day: "thursday",
          icon: null,
          rules: [],
          errors: [],
          valid: false,
          state: "",
          mode: "single",
          type: "checkbox",
          disable: false,
          value: null,
          subgroupData: [
            {
              name: "thrfromtime",
              label: "From Time",
              placeholder: "Select From Time",
              icon: null,
              rules: [],
              errors: [],
              valid: false,
              state: "",
              mode: "single",
              type: "time",
              disable: true,
              value: null,
            },
            {
              name: "thrtotime",
              label: "To Time",
              placeholder: "Select To Time",
              icon: null,
              rules: [],
              errors: [],
              valid: false,
              state: "",
              mode: "single",
              type: "time",
              disable: true,
              value: null,
            },
          ],
        },
        {
          name: 4,
          label: "Friday",
          placeholder: "Select day",
          business_day: "friday",

          icon: null,
          rules: [],
          errors: [],
          valid: false,
          state: "",
          mode: "single",
          type: "checkbox",
          disable: false,
          value: null,
          subgroupData: [
            {
              name: "frifromtime",
              label: "From Time",
              placeholder: "Select From Time",
              icon: null,
              rules: [],
              errors: [],
              valid: false,
              state: "",
              mode: "single",
              type: "time",
              disable: true,
              value: null,
            },
            {
              name: "fritotime",
              label: "To Time",
              placeholder: "Select To Time",
              icon: null,
              rules: [],
              errors: [],
              valid: false,
              state: "",
              mode: "single",
              type: "time",
              disable: true,
              value: null,
            },
          ],
        },
        {
          name: 5,
          label: "Saturday",
          placeholder: "Select day",
          business_day: "saturday",

          icon: null,
          rules: [],
          errors: [],
          valid: false,
          state: "",
          mode: "single",
          type: "checkbox",
          disable: false,
          value: null,
          subgroupData: [
            {
              name: "satfromtime",
              label: "From Time",
              placeholder: "Select From Time",
              icon: null,
              rules: [],
              errors: [],
              valid: false,
              state: "",
              mode: "single",
              type: "time",
              disable: true,
              value: null,
            },
            {
              name: "sattotime",
              label: "To Time",
              placeholder: "Select To Time",
              icon: null,
              rules: [],
              errors: [],
              valid: false,
              state: "",
              mode: "single",
              type: "time",
              disable: true,
              value: null,
            },
          ],
        },
        {
          name: 6,
          label: "Sunday",
          business_day: "sunday",
          placeholder: "Select day",
          icon: null,
          rules: [],
          errors: [],
          valid: false,
          state: "",
          mode: "single",
          type: "checkbox",
          disable: false,
          value: null,
          subgroupData: [
            {
              name: "sunfromtime",
              label: "From Time",
              placeholder: "Select From Time",
              icon: null,
              rules: [],
              errors: [],
              valid: false,
              state: "",
              mode: "single",
              type: "time",
              disable: true,
              value: null,
            },
            {
              name: "suntotime",
              label: "To Time",
              placeholder: "Select To Time",
              icon: null,
              rules: [],
              errors: [],
              valid: false,
              state: "",
              mode: "single",
              type: "time",
              disable: true,
              value: null,
            },
          ],
        },
      ],
    },
  ],
};

const assignOperator = {
  feilds: [
    // {
    //   name: "alloperator",
    //   label: "Operator *",
    //   placeholder: "Select Operator *",
    //   icon: null,
    //   rules: [],
    //   errors: [],
    //   valid: false,
    //   relation: true,
    //   relationvalue: [],
    //   state: "",
    //   mode: "single",
    //   type: "select2",
    //   disable: false,
    //   value: null,
    //   visiable: false,
    // },
    // {
    //   name: "technician",
    //   label: "Technician",
    //   placeholder: "Select Technician",
    //   icon: null,
    //   rules: [],
    //   errors: [],
    //   valid: false,
    //   relation: true,
    //   relationvalue: [],
    //   state: "",
    //   mode: "single",
    //   type: "select2",
    //   disable: false,
    //   value: null,
    //   visiable: false,
    // },
    // {
    //   name: "workstation",
    //   label: "Work Station",
    //   placeholder: "Select Workstation",
    //   icon: null,
    //   rules: [],
    //   errors: [],
    //   valid: false,
    //   relation: true,
    //   relationvalue: [],
    //   state: "",
    //   mode: "single",
    //   type: "select2",
    //   disable: false,
    //   value: null,
    //   visiable: false,
    // },
    // {
    //   name: "appointmentdc",
    //   label: "Appointment DC *",
    //   placeholder: "Select Appointment DC *",
    //   icon: null,
    //   rules: [],
    //   errors: [],
    //   valid: false,
    //   relation: true,
    //   relationvalue: [],
    //   state: "",
    //   mode: "single",
    //   type: "Select2multiple",
    //   disable: false,
    //   value: null,
    //   visiable: true,
    // },
    // {
    //   name: "earliestslotalog",
    //   label: "Include in Earliest Slot Appointments *",
    //   placeholder: "Select Include in Earliest Slot  *",
    //   icon: null,
    //   rules: [],
    //   errors: [],
    //   valid: false,
    //   state: "",
    //   relation: false,
    //   relationvalue: [],
    //   mode: "group",
    //   disable: true,
    //   value: null,
    //   type: "radio",
    //   styles: { label_cols: "col-4" },
    //   groupData: [
    //     {
    //       name: "yes",
    //       label: "Yes",
    //       placeholder: "Select",
    //       icon: null,
    //       rules: [],
    //       errors: [],
    //       valid: false,
    //       state: "",
    //       mode: "single",
    //       type: "radio",
    //       disable: false,
    //       value: null,
    //     },
    //     {
    //       name: "no",
    //       label: "No",
    //       placeholder: "Select",
    //       icon: null,
    //       rules: [],
    //       errors: [],
    //       valid: false,
    //       state: "",
    //       mode: "single",
    //       type: "radio",
    //       disable: false,
    //       value: null,
    //     },
    //   ],
    // },
  ],
};

const QueuePermission = [
  {
    id: 1,
    name: "Radiology",
    departments: ["DEP344", "DEP186", "DEP233"],
  },
  {
    id: 2,
    name: "Laboratory",
    departments: ["DEP324", "DEP350", "DEP5", "DEP280", "DEP279"],
  },
  {
    id: 3,
    name: "Pharmacy",
    departments: ["DEP40", "DEP148", "DEP394", "DEP395"],
  },
];

const radiologyAddForm = {
  feilds: [
    {
      id: 11,
      name: "roomNumber",
      text: "Room Number",
      visible: true,
      element: "input",
      required: true,
      input_type: "text",
      placeholder: "Enter Room Number",
      icon: null,
      rules: [
        {
          test: (value) => {
            return value.length > 0;
          },
          message: "Please Enter Your Room Number",
        },
      ],
      errors: [],
      value: null,
      valid: false,
      state: "",
      disable: false,
      className: [],
    },
    {
      id: 4,
      name: "doctor",
      text: "Doctor",
      visible: true,
      element: "select2",
      required: true,
      input_type: "select",
      placeholder: "Select Doctor",
      icon: "user",
      rules: [
        {
          test: (value) => {
            return value.length > 0;
          },
          message: "Please Enter Doctor",
        },
      ],
      errors: [],
      value: null,
      valid: false,
      state: "",
      disable: false,
      className: [],
    },
    {
      id: 5,
      name: "operator",
      text: "Operator",
      visible: true,
      element: "select2",
      required: true,
      input_type: "select",
      placeholder: "Select operator",
      icon: "user",
      rules: [
        {
          test: (value) => {
            return value.length > 0;
          },
          message: "Please Enter operator",
        },
      ],
      errors: [],
      value: null,
      valid: false,
      state: "",
      disable: false,
      className: [],
    },
    {
      id: 10,
      name: "button",
      text: "Add",
      visible: true,
      required: false,
      element: "button",
      input_type: "button",
      disable: false,
    },
  ],
};

const pharmaAddForm = {
  feilds: [
    {
      id: 5,
      name: "operator",
      text: "Operator",
      visible: true,
      element: "select2",
      required: true,
      input_type: "select",
      placeholder: "Select operator",
      icon: "user",
      rules: [
        {
          test: (value) => {
            return value.length > 0;
          },
          message: "Please Enter operator",
        },
      ],
      errors: [],
      value: null,
      valid: false,
      state: "",
      disable: false,
      className: [],
    },
    {
      id: 4,
      name: "chemist",
      text: "chemist",
      visible: true,
      element: "select2",
      required: true,
      input_type: "select",
      placeholder: "select Chemist",
      icon: "user",
      rules: [
        {
          test: (value) => {
            return value.length > 0;
          },
          message: "Please Enter Chemist",
        },
      ],
      errors: [],
      value: null,
      valid: false,
      state: "",
      disable: false,
      className: [],
    },
    {
      id: 4,
      name: "dispatcher",
      text: "Dispatcher",
      visible: true,
      element: "select2",
      required: true,
      input_type: "select",
      placeholder: "select Dispatcher",
      icon: "user",
      rules: [
        {
          test: (value) => {
            return value.length > 0;
          },
          message: "Please Enter Dispatcher",
        },
      ],
      errors: [],
      value: null,
      valid: false,
      state: "",
      disable: false,
      className: [],
    },
    {
      id: 10,
      name: "button",
      text: "Add",
      visible: true,
      required: false,
      element: "button",
      input_type: "button",
      disable: false,
    },
  ],
};

const labAddForm = {
  feilds: [
    {
      id: 11,
      name: "counterNumber",
      text: "Counter Number",
      visible: true,
      element: "input",
      required: true,
      input_type: "text",
      placeholder: "Enter Counter Number",
      icon: null,
      rules: [
        {
          test: (value) => {
            return value.length > 0;
          },
          message: "Please Enter Your Counter Number",
        },
      ],
      errors: [],
      value: null,
      valid: false,
      state: "",
      disable: false,
      className: [],
    },
    {
      id: 4,
      name: "plebo",
      text: "Plebo",
      visible: true,
      element: "select2",
      required: true,
      input_type: "select",
      placeholder: "select Plebo",
      icon: "user",
      rules: [
        {
          test: (value) => {
            return value.length > 0;
          },
          message: "Please Enter Plebo",
        },
      ],
      errors: [],
      value: null,
      valid: false,
      state: "",
      disable: false,
      className: [],
    },
    {
      id: 5,
      name: "operator",
      text: "Operator",
      visible: true,
      element: "select2",
      required: true,
      input_type: "select",
      placeholder: "Select operator",
      icon: "user",
      rules: [
        {
          test: (value) => {
            return value.length > 0;
          },
          message: "Please Enter operator",
        },
      ],
      errors: [],
      value: null,
      valid: false,
      state: "",
      disable: false,
      className: [],
    },
    {
      id: 10,
      name: "button",
      text: "Add",
      visible: true,
      required: false,
      element: "button",
      input_type: "button",
      disable: false,
    },
  ],
};
const roomDurationSchema = {
  feilds: [
    {
      id: 2,
      name: "roomduration",
      text: "Room Duration %",
      visible: true,
      icon: "file",
      element: "input",
      required: true,
      input_type: "number",
      placeholder: "Room Duration %",
      rules: [
        {
          test: (value) => {
            return (
              value !== null &&
              value.length > 0 &&
              value >= 0 &&
              value !== undefined
            );
          },
          message: "Please Enter Valid Room Duration %",
        },
      ],
      errors: [],
      value: null,
      valid: false,
      state: "",
      disable: false,
      className: "col-8",
    },
  ],
};

export {
  addQueue,
  QueuePermission,
  radiologyAddForm,
  pharmaAddForm,
  labAddForm,
  assignOperator,
  roomDurationSchema,
};
